import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

function AppActionDropDown({
  appActHideShow,
  setAppActHideShow,
  handleAppChange,
  handleAppStatusAct,
  isRecurring = false,
}) {
  const ref = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setAppActHideShow && setAppActHideShow(true);
      }
    };

    document.addEventListener('click', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [setAppActHideShow, appActHideShow, ref]);

  return (
    <>
      <div
        ref={ref}
        className={
          appActHideShow === true
            ? 'apsch-actn-contnr hide'
            : 'apsch-actn-contnr'
        }
        style={{ width: '150px', padding: 'unset' }}
      >
        <div className="apsch-actn-contnr-child">
          <span className="appt-action-links" onClick={handleAppChange}>
            <Link>Change</Link>
          </span>
        </div>
        <div className="apsch-actn-contnr-child">
          <span
            className="appt-action-links"
            onClick={() => handleAppStatusAct('del')}
          >
            <Link>Delete</Link>
          </span>
        </div>
        <div className="apsch-actn-contnr-child">
          <span
            className="appt-action-links"
            onClick={() => handleAppStatusAct('can')}
          >
            <Link>Cancel</Link>
          </span>
        </div>
        <div className="apsch-actn-contnr-child">
          <span
            className="appt-action-links"
            onClick={() => handleAppStatusAct('noso')}
          >
            <Link>No Show</Link>
          </span>
        </div>
        {!isRecurring && (
          <div className="apsch-actn-contnr-child">
            <span
              className="appt-action-links"
              onClick={() => handleAppStatusAct('resch')}
            >
              <Link>Reschedule</Link>
            </span>
          </div>
        )}
      </div>
    </>
  );
}

export default AppActionDropDown;
